import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_CEP_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, PaisRequest } from './types';

// ACTIONS
import { paisSuccess, paisFailure } from './actions';

function* paisRequest(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: PaisRequest } = request;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_CEP_API,
		`paises?nome=${payload}`,
	);

	if (response.status === 200 || response.status === 202) {
		yield put(paisSuccess(response.data));
	} else {
		yield put(paisFailure([]));
	}
}

export default all([takeLatest(Types.PAIS, paisRequest)]);
